import { useMemo } from 'react'
import IconPhysics from '@ucheba/ui/icons/icon__atom.svg'
import IconMathematics from '@ucheba/ui/icons/icon__math.svg'
import IconRussian from '@ucheba/ui/icons/icon__russian.svg'
import IconInformatics from '@ucheba/ui/icons/icon__mouse.svg'
import IconSocial from '@ucheba/ui/icons/icon__socium.svg'
import IconGeography from '@ucheba/ui/icons/icon__geo.svg'
import IconEnglish from '@ucheba/ui/icons/icon__english.svg'
import IconChemistry from '@ucheba/ui/icons/icon__chimstery.svg'
import IconLiterature from '@ucheba/ui/icons/icon__pero.svg'
import IconHistory from '@ucheba/ui/icons/icon__history.svg'
import IconBiology from '@ucheba/ui/icons/icon__dnk.svg'
import IconForeignlanguage from '@ucheba/ui/icons/icon__lang-message.svg'
import { EModColorBgText } from '@ucheba/utils/helpers/styles/mod.types'
import { EProgramStartType, IProgram } from '@ucheba/store/institutions/programs/types'
import { capitalizeFirstLetter } from '@ucheba/utils/helpers/string'
import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { programTypesHeight } from './constants'

interface IUseProgramListItemCore {
  (): {
    icons: {
      [key: string]: any
    }
  }
}

export const useProgramListItemCore: IUseProgramListItemCore = () => {
  const icons = useMemo(() => {
    return {
      mathematics: IconMathematics,
      russian: IconRussian,
      informatics: IconInformatics,
      foreignlanguage: IconForeignlanguage,
      social: IconSocial,
      physics: IconPhysics,
      geography: IconGeography,
      english: IconEnglish,
      chemistry: IconChemistry,
      literature: IconLiterature,
      history: IconHistory,
      biology: IconBiology,
    }
  }, [])

  return {
    icons,
  }
}

interface IProbability<T = never> {
  txt: string
  color: keyof typeof EModColorBgText | T
}
export const useProbability = (num: number | null | undefined): IProbability | null => {
  if (num) {
    if (num < 50) return { txt: 'низкие шансы', color: 'rose50' }
    if (num < 90) return { txt: 'средние шансы', color: 'yellow' }
    if (num >= 90) return { txt: 'высокие шансы', color: 'lime' }
  }

  return null
}

interface IUseProgramsProgramType {
  (programTypes: number): {
    isCourses: boolean
  }
}
export const useProgramsProgramType: IUseProgramsProgramType = (programTypes) => {
  const isCourses = useMemo(() => {
    return !programTypesHeight.includes(programTypes)
  }, [programTypes])

  return {
    isCourses,
  }
}

interface IUseNearestDate {
  (trainingForm: IProgram['trainingForm']): string | null
}

export const useNearestDate: IUseNearestDate = (trainingForm) => {
  return useMemo(() => {
    if (trainingForm) {
      const { nearestDate, startType } = trainingForm

      if (startType) {
        if (startType.value === EProgramStartType.date) {
          if (nearestDate) {
            if (nearestDate.isMonthStartAt) {
              return (
                nearestDate.dateFrom &&
                capitalizeFirstLetter(dayjs(nearestDate.dateFrom).format('MMMM'))
              )
            }

            return (
              nearestDate.dateFrom && dayjs(nearestDate.dateFrom).format('D MMMM, dddd')
            )
          }

          return null
        }

        return startType.name
      }

      return null
    }

    return null
  }, [trainingForm])
}
